export enum PageTypeEnum {
  footer = 'footer',
  pdp = 'pdp'
}
